import { Box } from "@mantine/core";

// Geometry of the phone in the dashboard preview (templates/sv/pv/thm/28 and
// css/widget-preview/laptop-2.css) - the studio preview has to match it.
const FRAME_WIDTH = 373;
const FRAME_HEIGHT = 755;
const SCREEN = { top: 30, left: 38, width: 300, height: 680, scale: 0.95 };

export function PreviewDeviceFrame({ children }) {
  return (
    <Box pos="relative" w={FRAME_WIDTH} h={FRAME_HEIGHT} style={{ flex: "none" }}>
      <svg
        width={FRAME_WIDTH}
        height={FRAME_HEIGHT}
        viewBox="0 0 373 755"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: "absolute", top: 0, left: 0 }}
      >
      <g filter="url(#filter0_d_853_5821)">
      <path d="M290.891 18.6145C322.618 18.6145 348.337 44.3343 348.337 76.0608V236.081H348.833C349.375 236.081 349.815 236.521 349.815 237.064V315.115C349.815 315.658 349.375 316.097 348.833 316.097H348.337V671.168C348.337 702.895 322.618 728.615 290.891 728.615H81.7837C50.0572 728.615 24.3374 702.895 24.3374 671.168V76.0608C24.3374 44.3343 50.0572 18.6145 81.7837 18.6145H290.891ZM23.8149 315.607H23.3198C22.7777 315.607 22.3377 315.167 22.3374 314.625V267.99C22.3374 267.448 22.7775 267.008 23.3198 267.008H23.8149V315.607ZM23.8149 250.808H23.3198C22.7777 250.808 22.3377 250.369 22.3374 249.826V203.192C22.3374 202.649 22.7775 202.209 23.3198 202.209H23.8149V250.808ZM23.8149 176.683H23.3198C22.7775 176.683 22.3374 176.243 22.3374 175.7V151.648C22.3374 151.105 22.7775 150.665 23.3198 150.665H23.8149V176.683Z" fill="#EBEEF1"/>
      <rect x="25.3374" y="19.6145" width="322" height="708" rx="56.4459" stroke="white" strokeWidth="2"/>
      <g clipPath="url(#clip0_853_5821)">
      <rect x="36.3374" y="32.6145" width="300" height="682" rx="45" fill="white"/>
      <rect width="300" height="682" transform="translate(36.3374 32.6145)" fill="white"/>
      <rect x="139.648" y="704.115" width="107" height="4" rx="2" fill="#EBEEF1"/>
      </g>
      </g>
      <defs>
      <filter id="filter0_d_853_5821" x="6.48499e-05" y="5.43594e-05" width="372.675" height="754.675" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
      <feFlood floodOpacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dy="3.72289"/>
      <feGaussianBlur stdDeviation="11.1687"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0.862745 0 0 0 0 0.905882 0 0 0 0 0.94902 0 0 0 0.5 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_853_5821"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_853_5821" result="shape"/>
      </filter>
      <clipPath id="clip0_853_5821">
      <rect x="36.3374" y="32.6145" width="300" height="682" rx="45" fill="white"/>
      </clipPath>
      </defs>
      </svg>
      <Box
        pos="absolute"
        top={SCREEN.top}
        left={SCREEN.left}
        w={SCREEN.width}
        h={SCREEN.height}
        style={{
          borderRadius: "20px 20px 30px 30px",
          overflow: "hidden",
          transform: `scale(${SCREEN.scale})`,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

export const PHONE_SCREEN = SCREEN;
